import { slice } from "./slice";
import * as actions from "./actions";
import * as selectors from "./selectors";

export { actions };
export { selectors };

export default slice.reducer;
